<script>
  import Step from "./Step.svelte";
  import StepHeader from "./StepHeader.svelte";

  export let course;
  export let mod;
  export let step;
  export let justified;
  export let prevFn;
  export let nextFn;
</script>

<Step {justified} {prevFn} {nextFn}>
  <StepHeader {course} {mod} />

  <div class="card w-2/3 mt-14 pt-4 mb-4 border-2 border-secondary relative">
    <span class="absolute -top-6 -left-8 border-2 border-secondary text-2xl bg-base-100 py-2 px-4 font-bold"> {step.title} </span> 

    <div class="card-body prose max-w-none">
      {@html step.content}
    </div>
  </div>
</Step>

